import { Paper } from '@mantine/core';
import type { ReactNode } from 'react';
import { NAVBAR_WIDTH } from '../AppLayout/AppLayout.js';

/** The navbar's own width plus its 16px gutter — the bar's left edge above `sm`. */
export const FLOATING_BAR_LEFT = NAVBAR_WIDTH + 16;

/**
 * The floating pill fixed above the content: the master editor's Save bar and the grid's
 * selection bar share this shape (surface, border, radius, shadow, position) and used to
 * hand-roll it separately. `left` narrows below `sm`, where there is no navbar to clear; `bottom`
 * makes room for the safe-area inset on a phone with a home indicator.
 */
export const FloatingActionBar = ({
    children,
    ariaLabel,
    left = FLOATING_BAR_LEFT,
    bottom = 16,
}: {
    children: ReactNode;
    ariaLabel: string;
    left?: number;
    bottom?: number | string;
}) => (
    <Paper
        shadow="xl"
        radius="lg"
        withBorder
        p={8}
        pl="sm"
        role="region"
        aria-label={ariaLabel}
        style={{
            position: 'fixed',
            left,
            right: 8,
            bottom,
            marginInline: 'auto',
            maxWidth: 760,
            zIndex: 180,
            background: 'var(--rgs-surface)',
            borderColor: 'var(--rgs-line)',
        }}
    >
        {children}
    </Paper>
);
